import React, { Component } from "react";

import {
  CButton,
  CCol,
  CRow,
  CSpinner,
  CCollapse,
  CModal,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";
import socketIOClient from "socket.io-client";

import { logout } from "../../../../actions/baseActions";
import { setObj, showHelpdesk } from "../../../../actions/noteActions";
import ImgNoData from "../../../../assets/imgs/graduation.svg";
import ApplicatedQuestionList from "../../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Breadcrumb from "../../../../components/Breadcrumb";
import CorrectLiveModal from "../../../../components/CorrectLiveModal";
import DragAndDropLive from "../../../../components/DragAndDrop/DragAndDropLive";
import Interface from "../../../../components/Interface";
import JitsiStudent from "../../../../components/Jitsi/student";
import JitsiTeacher from "../../../../components/Jitsi/teacher";
import LiterarteModal from "../../../../components/LiterarteModal";
import ModalTools from "../../../../components/ModalTools";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import ShareModal from "../../../../components/ShareModal";
import Students from "../../../../components/Students/Students";
import UploadModal from "../../../../components/UploadModal";
import Widgets from "../../../../components/Widgets/Widgets";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { baseDate } from "../../../../utils/date";
import { caminhoDoLo } from "../../../../utils/loSingleView";

import "./style.scss";

const Dropbox = require("dropbox");
const FileDownload = require("js-file-download");

class ActivityLive extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recording: "stopped",
      // endpoint: URL.node,
      studentsList: [],
      // teachersList: [],
      user: {},
      activity: null,
      room_id: null,
      activity_id: null,
      allocation_id: this.props.match.params.allocation_id,
      activity_name: "",
      messages: [],
      // message: "",
      execution_id: null,
      // socket: this.props.socket,
      loading: true,
      discipline: null,
      iframe: false,
      // questions: [],
      listQuestion: {
        id: "",
        show: false,
        average: 0
      },
      textProduction: {
        id: "",
        show: false,
        value: [
          {
            type: "paragraph",
            children: [{ text: "" }]
          }
        ]
      },
      // ability_list: [],
      contentId: "",
      contentName: "",
      totalActivityItems: 0,
      modalTool: false,
      toolName: null,
      toolId: null,
      leftCollapse: true,
      rightCollapse: true,
      jitsi: true,
      jitsiObj: null,
      jitsiCollapse: false,
      shareModal: false,
      uploadModal: false,
      item_id: null,
      literarteStart: null,
      selectedUser: null,
      modalCorrect: false,
      url: null
    };

    this.dragAndDropLive = React.createRef();
    this.error = this.error.bind(this);
    this.chatMount = this.chatMount.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  createExecution(callback = () => null) {
    const obj = {
      allocation_id: this.state.allocation_id
    };

    axios
      .post(`${URL.api}activity/execution/insertByAllocation`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          this.setState({ execution_id: resp.data.data }, () => callback());
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução da atividade!");
        }
      });
  }

  componentDidMount() {
    window.addEventListener("beforeunload", event => {
      this.socketRoomEmit(
        `aula_ao_vivo_${this.state.allocation_id}`,
        { user: this.state.user },
        "leaveRoomNotification"
      );
      this.leaveRoom(`aula_ao_vivo_${this.state.allocation_id}`);
    });

    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleLive(() => this.initializeLive());

    if (![7, 8, 9].includes(this.props.general.active_roles.role_id)) {
      const accessToken =
        "rPBbXAhYoLUAAAAAAAAAAdyTictsKm-4CKuVCU3UVvnvxh11jSGVFjwJxsjZMqpM";

      this.dbx = new Dropbox.Dropbox({ accessToken });
    }
  }

  handleLive(callback = () => null) {
    if ([7, 8, 9].includes(this.props.general.active_roles.role_id)) {
      this.createExecution(() => {
        axios
          .get(
            `${URL.api}activity/activity/singleViewByExecution/${this.state.execution_id}?allocation_id=${this.state.allocation_id}`,
            {
              headers: {
                authorization: `Bearer ${this.props.user.token}`,
                "Access-Control-Allow-Origin": "*"
              }
            }
          )
          .then(resp => {
            if (resp.data.success) {
              const activity = {
                ...resp.data.data,
                items: resp.data.data.items.map(item => ({
                  ...item,
                  title: item.name,
                  subtitle: item.type_name
                }))
              };

              this.setState(
                {
                  activity,
                  itens: activity.items
                },
                () => {
                  callback();
                }
              );
            } else {
              this.error("Falha ao encontrar a atividade!");
            }
          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              this.error("Sua sessão expirou!");
              this.props.logout();
            } else {
              this.error("Falha ao encontrar a atividade!");
            }
          });
      });
    } else {
      axios
        .get(
          `${URL.api}activity/activity/singleViewByAllocation/${this.state.allocation_id}`,
          {
            headers: {
              authorization: `Bearer ${this.props.user.token}`,
              "Access-Control-Allow-Origin": "*"
            }
          }
        )
        .then(resp => {
          this.setState({ discipline: resp.data.data.discipline_id });
          if (resp.data.success) {
            const activity = {
              ...resp.data.data,
              items: resp.data.data.items.map(item => ({
                ...item,
                title: item.name,
                subtitle: item.type_name
              }))
            };

            this.setState(
              {
                activity,
                itens: activity.items
              },
              () => {
                callback();
              }
            );
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.error("Sua sessão expirou!");
            this.props.logout();
          } else {
            this.error("Falha ao encontrar a atividade!");
          }
        });
    }
  }

  initializeLive() {
    let user = {
      id: this.props.user.user.id,
      name: this.props.user.user.username
    };

    let objActivityAllocate = {
      activity_id: this.state.activity.id,
      room_id: this.state.activity.room_id,
      user_id: 0
    };

    let objRoomUser = {
      room: this.state.activity.room_id
    };

    let objChat = {
      room_id: this.state.activity.room_id,
      activity_id: this.state.activity.id
    };

    const socket = socketIOClient(URL.node);
    // const socket = this.props.socket;

    axios
      .all([
        axios.post(`${URL.api}activity/allocate/list`, objActivityAllocate, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}activity/allocate/guests`, objActivityAllocate, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}community/room_user/list`, objRoomUser, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}communication/chat/list`, objChat, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (respAllocate, respAllocateGuests, respUsersList, respChat) => {
            let studentsList = [];
            let teachersList = [];

            // listar usuários alocados/da turma
            if (respAllocate.data.data[0].users.length > 0) {
              for (let i = 0; i < respAllocate.data.data[0].users.length; i++) {
                for (let j = 0; j < respUsersList.data.data.length; j++) {
                  let obj = {
                    id: respUsersList.data.data[j].user_id,
                    name: respUsersList.data.data[j].user_name,
                    online: "desconectado",
                    color: "dark",
                    activity: "",
                    profileImage:
                      URL.img +
                      (respUsersList.data.data[j].user_photo ||
                        "uploads/users/profileEmpty.jpg"),
                    role_id: 7
                  };
                  if (
                    respAllocate.data.data[0].users[i].user_id ===
                    respUsersList.data.data[j].user_id
                  ) {
                    if (
                      [7, 8, 9].includes(respUsersList.data.data[j].role_id)
                    ) {
                      studentsList.push(obj);
                    } else {
                      teachersList.push(obj);
                    }
                  }
                }
              }
            } else {
              for (let i = 0; i < respUsersList.data.data.length; i++) {
                let obj = {
                  id: respUsersList.data.data[i].user_id,
                  name: respUsersList.data.data[i].user_name,
                  online: "desconectado",
                  color: "dark",
                  activity: "",
                  profileImage:
                    URL.img +
                    (respUsersList.data.data[i].user_photo ||
                      "uploads/users/profileEmpty.jpg"),
                  role_id: 7
                };
                if ([7, 8, 9].includes(respUsersList.data.data[i].role_id)) {
                  studentsList.push(obj);
                } else {
                  teachersList.push(obj);
                }
              }
            }

            for (let i = 0; i < respAllocateGuests.data.data.length; i++) {
              let obj = {
                id: respAllocateGuests.data.data[i].user_id,
                name: respAllocateGuests.data.data[i].user_name,
                online: "desconectado",
                color: "dark",
                activity: "",
                profileImage:
                  URL.img +
                  (respAllocateGuests.data.data[i].user_photo ||
                    "uploads/users/profileEmpty.jpg"),
                role_id: 9
              };

              studentsList.push(obj);
            }

            // listar itens
            let listQuestion = {
              id: "",
              show: false,
              average: 0
            };

            const activity = {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.activity,
              // eslint-disable-next-line react/no-access-state-in-setstate
              items: this.state.activity.items.map(item => ({
                ...item,
                title: item.name,
                subtitle: item.type_name
              }))
            };

            let jitsi = true;

            if (
              new Date(activity.activity_end) < new Date() ||
              new Date(activity.activity_start) > new Date()
            ) {
              jitsi = false;
            }

            this.setState(
              {
                loading: false,
                activity,
                activity_id: activity.id,
                professor_name: activity.user_name,
                professor_photo: activity.user_photo,
                activity_name: activity.name,
                listQuestion,
                socket,
                room_id: activity.room_id,
                room_name: activity.room_name,
                discipline_name: activity.discipline_name,
                totalActivityItems: activity.items.length,
                studentsList,
                // teachersList,
                user,
                jitsi,
                itens: activity.items
              },
              () => {
                let messages = this.chatMount(respChat.data.data);

                this.setState({ messages });
                this.state.socket.emit("enterRoom", {
                  room_name: `aula_ao_vivo_${this.state.allocation_id}`
                });
                if (this.props.general.active_roles.role_id === 6) {
                  this.socketRoomEmit(
                    `aula_ao_vivo_${this.state.allocation_id}`,
                    {},
                    "getUsersListRoom"
                  );

                  this.state.socket.on("enterRoomNotification", data => {
                    this.updateStudentsList("enter", data);
                  });

                  this.state.socket.on("leaveRoomNotification", data => {
                    this.updateStudentsList("leave", data);
                  });
                } else if (
                  [7, 8, 9].includes(this.props.general.active_roles.role_id)
                ) {
                  this.socketRoomEmit(
                    `aula_ao_vivo_${this.state.allocation_id}`,
                    { user },
                    "enterRoomNotification"
                  );

                  this.state.socket.on("getUsersListRoom", () => {
                    this.socketRoomEmit(
                      `aula_ao_vivo_${this.state.allocation_id}`,
                      { user: this.state.user },
                      "enterRoomNotification"
                    );
                  });
                }

                this.state.socket.on("insertItemLive", data => {
                  this.onInsertItem(data);
                });

                this.state.socket.on("removeItemLive", data => {
                  this.onRemoveItem(data);
                });

                this.state.socket.on("chatRoom", data => {
                  let chatRoom = [];
                  for (let i = 0; i < this.state.messages.length; i++) {
                    chatRoom[i] = this.state.messages[i];
                  }

                  let obj = {
                    author: data.user_id,
                    authorName: data.user_name,
                    message: data.message
                  };

                  chatRoom.push(obj);
                  this.chatMount([obj]);

                  this.setState({
                    messages: chatRoom
                  });
                });
              }
            );
          },
          error => {
            this.error("Não foi possível obter informações sobre a atividade");
          }
        )
      );
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", event => {});

    this.leaveRoom(`aula_ao_vivo_${this.state.allocation_id}`);

    if ([7, 8, 9].includes(this.props.general.active_roles.role_id)) {
      this.socketRoomEmit(
        `aula_ao_vivo_${this.state.allocation_id}`,
        { user: this.state.user },
        "leaveRoomNotification"
      );
    }
  }

  updateStudentsList = (status, data) => {
    let online;
    let color;
    if (status === "enter") {
      online = "conectado";
      color = "#44cc55";
    } else {
      online = "desconectado";
      color = "gray-400";
    }

    let studentsList = [];
    this.state.studentsList.forEach((student, index) => {
      studentsList.push(student);
    });

    for (let i = 0; i < studentsList.length; i++) {
      if (data.user.id === studentsList[i].id) {
        studentsList[i].online = online;
        studentsList[i].color = color;
        break;
      }
    }

    this.setState({ studentsList });
  };

  socketRoomEmit = (roomName, data, nameEvent) => {
    this.state.socket.emit("socketRoom", {
      room_name: roomName,
      data,
      nameEvent
    });
  };

  chatMount(data) {
    return data.map(message => ({
      author: message.send_user_id,
      authorName: message.send_user_name,
      message: message.message
    }));
  }

  addMessage = data => {
    let obj = {
      room_id: this.state.room_id,
      activity_id: this.state.activity_id,
      send_user_id: this.state.user.id,
      message: data
    };

    let obj2 = {
      user_id: this.state.user.id,
      user_name: this.state.user.name,
      message: data
    };

    this.socketRoomEmit(
      `aula_ao_vivo_${this.state.allocation_id}`,
      obj2,
      "chatRoom"
    );

    axios
      .post(`${URL.api}communication/chat/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {},
        error => {
          this.error("Não foi possível enviar a mensagem");
        }
      );
  };

  createItemExecution(item, finished, callback = () => null) {
    const late = Date.parse(this.state.activity.activity_end) < Date.now();

    if (finished || late) {
      callback();
      return;
    }

    const obj = {
      execution_id: this.state.execution_id,
      item_id: item,
      completion_percentage: 100,
      start: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString(),
      end: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000
      ).toISOString()
    };

    axios
      .post(`${URL.api}activity/execution/item/insert`, obj, {
        headers: {
          authorization: `Bearer ${this.props.user.token}`,
          "Access-Control-Allow-Origin": "*"
        }
      })
      .then(resp => {
        if (resp.data.success) {
          callback();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          this.error("Sua sessão expirou!");
          this.props.logout();
        } else {
          this.error("Falha ao criar a execução do item!");
        }
      });
  }

  openItem = item => {
    const late = Date.parse(this.state.activity.activity_end) < Date.now();

    const tryCreateItemExecution = () => {
      if (
        item.id &&
        [7, 8, 9].includes(this.props.general.active_roles.role_id)
      ) {
        this.createItemExecution(item.id, item.item_percentage === 100);
      }
    };

    if (item.type_id === 12) {
      this.setState({
        listQuestion: {
          id: item.obj_id,
          show: true
        },
        contentId: item.obj_id,
        contentName: item.title,
        item_id: item.id
      });
    } else if (item.type_id === 23) {
      window.open(item.link, "_blank");
    } else if (item.type_id === 15) {
      // NEWTON
      this.setState({
        modalTool: true,
        toolId: item.type_id,
        toolName: item.title,
        item_id: item.id
      });

      tryCreateItemExecution();
    } else if (item.type_id === 16) {
      // LINK
      axios
        .get(`${URL.api}content/los/singleView/${item.obj_id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(
          resp => {
            window.open(caminhoDoLo(resp), "_blank");

            tryCreateItemExecution();
          },
          () => {
            toastr.error(
              "Falha",
              "Não foi possível abrir o link. Tente novamente!"
            );
          }
        );
    } else if (item.type_id === 14) {
      // LITERARTE
      if (late && item.item_percentage !== 100) {
        toastr.warning("Atenção", "A atividade já foi encerrada!");
        return;
      }

      this.setState({
        textProduction: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          ...this.state.textProduction,
          show: true,
          id: item.obj_id
        },
        item_id: item.id,
        contentName: item.title,
        literarteStart: new Date()
      });
    } else if (item.type_id === 18) {
      if (item.item_percentage === 100) {
        toastr.info(
          "Item realizado",
          item.item_grade
            ? `Você tirou a nota ${item.item_grade}`
            : "A correção ainda não está disponível"
        );
      } else {
        this.setState({
          uploadModal: true,
          contentId: item.obj_id,
          contentName: item.title,
          item_id: item.id
        });
      }
    } else if (![17, 23].includes(item.type_id)) {
      this.setState({
        iframe: true,
        contentId: item.obj_id,
        contentName: item.title,
        item_id: item.id
      });
    } else {
      if (item.link?.endsWith(".pdf")) {
        this.setState({
          iframe: true,
          contentId: null,
          contentName: item.title,
          item_id: item.id,
          url: item.link
        });

        tryCreateItemExecution();
        return;
      }

      const downloadPath = item.link
        ? item.link.substring(item.link.indexOf("uploads/") + 8)
        : `${item.obj_id === 1 ? "activity" : "repo"}/${item.name}`;

      axios
        .get(`${URL.api}download/${downloadPath}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          responseType: "blob"
        })
        .then(resp => {
          FileDownload(resp.data, item.name);

          tryCreateItemExecution();
        });
    }
  };

  leaveRoom = roomName => {
    this.state.socket.emit("leaveRoom", roomName);
  };

  insertActivityItem(item) {
    const obj = {
      ...item,
      activity_id: this.state.activity_id,
      order: this.state.itens.length + 1
    };

    axios
      .post(`${URL.api}activity/item/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          const items = [];

          this.socketRoomEmit(
            `aula_ao_vivo_${this.state.allocation_id}`,
            { ...item, id: resp.data.data },
            "insertItemLive"
          );

          this.state.itens.forEach(stateItem => {
            if (
              stateItem.type_id === item.type_id &&
              stateItem.obj_id === item.obj_id
            ) {
              items.push({
                ...stateItem,
                id: resp.data.data
              });
            } else {
              items.push(stateItem);
            }
          });

          this.setState({ itens: items });
        }
      });
  }

  removeActivityItem(item) {
    const { id } = this.state.itens.find(
      stateItem =>
        stateItem.type_id === item.type_id && stateItem.obj_id === item.obj_id
    );

    this.socketRoomEmit(
      `aula_ao_vivo_${this.state.allocation_id}`,
      item,
      "removeItemLive"
    );

    axios
      .delete(`${URL.api}activity/item/delete/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          const items = [];

          this.state.itens.forEach(stateItem => {
            if (stateItem.id !== id) {
              items.push(stateItem);
            }
          });

          this.setState({ itens: items });
        }
      });
  }

  onInsertItem(item) {
    this.setState(
      state => ({ itens: [...state.itens, item] }),
      () => {
        if ([7, 8, 9].includes(this.props.general.active_roles.role_id)) {
          this.openItem(item);
        }
      }
    );
  }

  onRemoveItem(item) {
    this.setState(
      state => ({
        itens: state.itens.filter(
          stateItem =>
            stateItem.type_id !== item.type_id ||
            stateItem.obj_id !== item.obj_id
        )
      }),
      () => {
        if (item.type_id === 12 && this.state.listQuestion.id === item.obj_id) {
          this.setState({
            listQuestion: {
              id: "",
              show: false
            }
          });
        } else if (item.type_id === 24 && item.type_id === this.state.toolId) {
          this.setState({ modalTool: false });
        } else if (
          item.type_id !== 17 &&
          item.obj_id === this.state.contentId
        ) {
          this.setState({ iframe: false });
        }
      }
    );
  }

  saveTextProduction = pages => {
    let pagesObj = [];
    for (let i = 0; i < pages.length; i++) {
      pagesObj.push({
        number: i,
        content: JSON.stringify(pages[i])
      });
    }

    let obj = {
      user_id: this.props.user.user.id,
      literarte_activity_id: 1,
      pages: pagesObj,
      item_id: this.state.item_id,
      execution_id: this.state.execution_id,
      start: baseDate(this.state.literarteStart),
      end: baseDate(new Date())
    };

    axios
      .post(`${URL.api}literarte/production_create`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        if (resp.data.success) {
          toastr.success("Sucesso", "O texto foi salvo.");
          this.setState({
            textProduction: {
              // eslint-disable-next-line react/no-access-state-in-setstate
              ...this.state.textProduction,
              show: false
            }
          });
        }
      });
  };

  getJitsiRoomName() {
    const removeSpecial = str => {
      str = str.toLowerCase();
      str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      str = str.replace(/[^\w\s]/gi, "");

      return str.replace(" ", "");
    };
    return `${removeSpecial(this.state.room_name || "sala")}-${removeSpecial(
      this.state.professor_name || "professor"
    )}-${removeSpecial(this.state.discipline_name || "disciplina")}`;
  }

  startRecording() {
    this.state.jitsiObj.executeCommand("startRecording", {
      mode: "file", // recording mode, either `file` or `stream`.
      dropboxToken:
        "G4iT-YvT89EAAAAAAAAAATWTYTblO14JCRYNjWyZ1pFqurouqiGQDVXc6M2rqkR3" // Generated access token
    });

    this.setState({ recording: "starting" });
  }

  stopRecording() {
    this.state.jitsiObj.executeCommand("stopRecording", "file");
    this.setState({ recording: "stopping" });
  }

  onStartRecording() {
    this.setState({ recording: "started" });
  }

  onStopRecording() {
    this.setState({ recording: "stopped" });

    const name = this.getJitsiRoomName();

    const dropBd = async nome => {
      const caminho = await this.dbx.filesListFolder({
        path: "/recordings"
      });
      let nomeDaSala = nome;
      const arquivos = caminho.result.entries; // array de de objetos(files)
      const ultimoArquivo = arquivos.length - 1; // posicao do último arquivo no array

      let pathDoArquivo = arquivos[ultimoArquivo].path_lower;

      this.dbx
        .sharingCreateSharedLinkWithSettings({ path: pathDoArquivo })
        .then(response => {
          const retornoUrl = response.result.url;

          axios
            .post(
              `${URL.api}community/room_recording/insertJitsi`,
              {
                room_id: this.state.room_id,
                activity_id: this.state.activity_id,
                link: retornoUrl
              },
              { headers: { Authorization: `Bearer ${this.props.user.token}` } }
            )
            .then(
              resp => {
                if (!resp.data.success) {
                  this.error("Não foi possível salvar a gravação!");
                }
              },
              error => {
                this.error("Não foi possível salvar a gravação!");
              }
            );
        })
        .catch(error => {
          alert("Já existe um link compartilhável para essa URL");
        });
    };

    setTimeout(() => {
      dropBd(name);
    }, 11200);
  }

  stats() {
    const numberOfParticipants = this.state.jitsiObj.getNumberOfParticipants();
    const infor = this.state.jitsiObj.getParticipantsInfo();
    let estat = {
      numeroDeAlunos: numberOfParticipants,
      infoAlunos: infor
    };

    let algo = estat.infoAlunos.map(item => {
      if (item.displayName) {
        return ` ${item.displayName}`;
      }

      return "";
    });

    alert(
      `Número de Participantes: ${estat.numeroDeAlunos}; Participantes: ${algo}`
    );
  }

  render() {
    const late =
      !this.state.loading &&
      new Date(this.state.activity.activity_end) < new Date();
    const soon =
      !this.state.loading &&
      new Date(this.state.activity.activity_start) > new Date();

    return (
      <div>
        {!this.state.loading ? (
          <div
            className="d-flex flex-column"
            style={{ width: "100vw", height: "100vh" }}
          >
            {this.state.iframe && (
              <Interface
                show={this.state.iframe}
                title={this.state.contentName}
                onClose={() => this.setState({ iframe: false })}
                aula={this.state.contentId}
                atividade={this.state.activity_id}
                currentRoute={this.props.currentRoute}
                act_item_id={this.state.item_id}
                act_execution_id={late ? undefined : this.state.execution_id}
                url={!this.state.contentId && this.state.url}
              />
            )}
            <ModalTools
              show={this.state.modalTool}
              tool={this.state.toolId}
              title={this.state.toolName}
              onClose={() => this.setState({ modalTool: false })}
              activity={this.state.activity_id}
              students={this.state.studentsList}
              currentRoute={this.props.currentRoute}
            />
            <ShareModal
              show={this.state.shareModal}
              onClose={() => this.setState({ shareModal: false })}
              link={window.location.href}
            />
            {this.state.modalCorrect && (
              <CorrectLiveModal
                allocationId={this.state.allocation_id}
                activityId={this.state.activity_id}
                userId={this.state.selectedUser}
                onClose={() => this.setState({ modalCorrect: false })}
              />
            )}
            {this.state.uploadModal && (
              <UploadModal
                onClose={() =>
                  this.setState({ uploadModal: false }, () =>
                    this.handleActivity()
                  )
                }
                upload_id={this.state.contentId}
                activity_id={this.state.activity_id}
                item_id={this.state.item_id}
                execution_id={this.state.execution_id}
              />
            )}
            {this.state.textProduction.id !== "" ? (
              <LiterarteModal
                id={this.state.textProduction.id}
                show={this.state.textProduction.show}
                onClose={() =>
                  this.setState({
                    textProduction: {
                      // eslint-disable-next-line react/no-access-state-in-setstate
                      ...this.state.textProduction,
                      show: false
                    }
                  })
                }
                title={this.state.contentName}
                value={this.state.textProduction.value}
                onChange={value =>
                  this.setState({
                    textProduction: {
                      // eslint-disable-next-line react/no-access-state-in-setstate
                      ...this.state.textProduction,
                      value
                    }
                  })
                }
                saveTextProduction={pages => this.saveTextProduction(pages)}
              />
            ) : null}
            {this.state.listQuestion.id !== "" ? (
              <CModal
                show={this.state.listQuestion.show}
                onClose={() =>
                  this.setState({
                    listQuestion: {
                      id: "",
                      show: false
                    }
                  })
                }
                size="lg w-100 h-100 m-0 p-2 mw-100"
                style={{ width: "100%", height: "100%" }}
                closeOnBackdrop={false}
              >
                <CModalHeader close>
                  <CModalTitle>{this.state.contentName}</CModalTitle>
                </CModalHeader>
                {this.state.listQuestion.show && (
                  <ApplicatedQuestionList
                    activityId={this.state.activity_id}
                    currentRoute={this.props.currentRoute}
                    allocation_id={this.state.allocation_id}
                    id={this.state.listQuestion.id}
                    history={this.props.history}
                    prototype={false}
                    item_id={this.state.item_id}
                    execution_id={this.state.execution_id}
                    result_type={this.state.activity.result_type}
                    ended={late}
                    try={1}
                    close={() =>
                      this.setState({
                        listQuestion: {
                          // eslint-disable-next-line react/no-access-state-in-setstate
                          id: this.state.listQuestion.id,
                          show: false
                        }
                      })
                    }
                  />
                )}
              </CModal>
            ) : (
              ""
            )}
            <div
              className={`activity-jitsi${
                !this.state.jitsi ? " minimized" : ""
              }`}
            >
              {[7, 8, 9].includes(this.props.general.active_roles.role_id) ? (
                <>
                  <div
                    className={`circle-live-menu${
                      !this.state.jitsi ? " d-none" : ""
                    }`}
                  >
                    {this.state.jitsiCollapse && (
                      <>
                        <div className="d-flex align-items-center position-relative mt-3">
                          <CButton
                            color="live"
                            className="d-flex justify-content-center align-items-center flex-column text-white"
                            style={{ height: "3.5rem", width: "3.5rem" }}
                            onClick={() =>
                              this.setState(state => ({
                                jitsi: !state.jitsi,
                                jitsiCollapse: false
                              }))
                            }
                          >
                            <i
                              className="fa fa-th-large"
                              style={{
                                width: "1.25rem",
                                height: "1.25rem",
                                fontSize: "1.25rem"
                              }}
                            ></i>
                          </CButton>
                          <span
                            className="text-white ml-3 text-ellipsis"
                            style={{ position: "absolute", left: "3.5rem" }}
                          >
                            Abrir itens da atividade
                          </span>
                        </div>
                        <div className="d-flex align-items-center position-relative mt-3">
                          <CButton
                            color="live"
                            className="d-flex justify-content-center align-items-center flex-column text-white"
                            style={{ height: "3.5rem", width: "3.5rem" }}
                            onClick={() =>
                              this.props.history.push(
                                `/classroom/${this.state.room_id}`
                              )
                            }
                          >
                            <i
                              className="fa fa-home"
                              style={{
                                width: "1.25rem",
                                height: "1.25rem",
                                fontSize: "1.25rem"
                              }}
                            ></i>
                          </CButton>
                          <span
                            className="text-white ml-3 text-ellipsis"
                            style={{ position: "absolute", left: "3.5rem" }}
                          >
                            Voltar para a plataforma
                          </span>
                        </div>
                      </>
                    )}
                    <CButton
                      color="live"
                      className={`d-flex justify-content-center align-items-center flex-column text-white mt-3${
                        this.state.jitsiCollapse ? " rotate" : ""
                      }`}
                      style={{ height: "4.6875rem", width: "4.6875rem" }}
                      onClick={() =>
                        this.setState(state => ({
                          jitsiCollapse: !state.jitsiCollapse
                        }))
                      }
                    >
                      <i
                        className="fa fa-plus"
                        style={{
                          width: "1.25rem",
                          height: "1.25rem",
                          fontSize: "1.25rem"
                        }}
                      ></i>
                    </CButton>
                  </div>
                  {!late && !soon && (
                    <JitsiStudent
                      room={this.getJitsiRoomName()}
                      user={this.props.user.user.name}
                      className="w-100 h-100"
                      onJitsi={jitsi => this.setState({ jitsiObj: jitsi })}
                    />
                  )}
                </>
              ) : (
                <>
                  <div
                    className={`circle-live-menu${
                      !this.state.jitsi ? " d-none" : ""
                    }`}
                  >
                    {this.state.jitsiCollapse && (
                      <>
                        {/* <div className="d-flex align-items-center position-relative mt-3">
                          <CButton
                            color="live"
                            className="d-flex justify-content-center align-items-center flex-column text-white"
                            style={{ height: "3.5rem", width: "3.5rem" }}
                            onClick={() => this.stats()}
                          >
                            <i
                              className="fa fa-pie-chart"
                              style={{
                                width: "1.25rem",
                                height: "1.25rem",
                                fontSize: "1.25rem"
                              }}
                            ></i>
                          </CButton>
                          <span
                            className="text-white ml-3 text-ellipsis"
                            style={{ position: "absolute", left: "3.5rem" }}
                          >
                            Estatísticas
                          </span>
                        </div> */}
                        <div className="d-flex align-items-center position-relative mt-3">
                          <CButton
                            color="live"
                            className="d-flex justify-content-center align-items-center flex-column text-white"
                            style={{ height: "3.5rem", width: "3.5rem" }}
                            onClick={() =>
                              this.dragAndDropLive.selectedItem(
                                { id: 12, name: "Lista de questões" },
                                true
                              )
                            }
                          >
                            <i
                              className="fa fa-check-square"
                              style={{
                                width: "1.25rem",
                                height: "1.25rem",
                                fontSize: "1.25rem"
                              }}
                            ></i>
                          </CButton>
                          <span
                            className="text-white ml-3 text-ellipsis"
                            style={{ position: "absolute", left: "3.5rem" }}
                          >
                            Disparar lista de questões
                          </span>
                        </div>
                        <div className="d-flex align-items-center position-relative mt-3">
                          <CButton
                            color="live"
                            className={`d-flex justify-content-center align-items-center flex-column text-white${
                              ["started", "stopping"].includes(
                                this.state.recording
                              )
                                ? " danger"
                                : ""
                            }`}
                            style={{ height: "3.5rem", width: "3.5rem" }}
                            onClick={() =>
                              this.state.recording === "started"
                                ? this.stopRecording()
                                : this.startRecording()
                            }
                          >
                            {this.state.recording === "stopped" ? (
                              <i
                                className="fa fa-circle text-danger"
                                style={{
                                  width: "1.25rem",
                                  height: "1.25rem",
                                  fontSize: "1.25rem"
                                }}
                              ></i>
                            ) : this.state.recording === "started" ? (
                              <i
                                className="fa fa-square"
                                style={{
                                  width: "1.25rem",
                                  height: "1.25rem",
                                  fontSize: "1.25rem"
                                }}
                              ></i>
                            ) : this.state.recording === "starting" ? (
                              <CSpinner
                                size="sm"
                                color="danger"
                                style={{
                                  width: "1.25rem",
                                  height: "1.25rem",
                                  fontSize: "1.25rem"
                                }}
                              />
                            ) : (
                              <CSpinner
                                size="sm"
                                color="white"
                                style={{
                                  width: "1.25rem",
                                  height: "1.25rem",
                                  fontSize: "1.25rem"
                                }}
                              />
                            )}
                          </CButton>
                          {this.state.recording === "stopped" ? (
                            <span
                              className="text-white ml-3 text-ellipsis"
                              style={{ position: "absolute", left: "3.5rem" }}
                            >
                              Gravar
                            </span>
                          ) : this.state.recording === "started" ? (
                            <span
                              className="text-white ml-3 text-ellipsis"
                              style={{ position: "absolute", left: "3.5rem" }}
                            >
                              Parar
                            </span>
                          ) : this.state.recording === "starting" ? (
                            <span
                              className="text-white ml-3 text-ellipsis"
                              style={{ position: "absolute", left: "3.5rem" }}
                            >
                              Iniciando gravação...
                            </span>
                          ) : (
                            <span
                              className="text-white ml-3 text-ellipsis"
                              style={{ position: "absolute", left: "3.5rem" }}
                            >
                              Parando gravação...
                            </span>
                          )}
                        </div>
                        <div className="d-flex align-items-center position-relative mt-3">
                          <CButton
                            color="live"
                            className="d-flex justify-content-center align-items-center flex-column text-white"
                            style={{ height: "3.5rem", width: "3.5rem" }}
                            onClick={() =>
                              this.setState(state => ({
                                jitsi: !state.jitsi,
                                jitsiCollapse: false
                              }))
                            }
                          >
                            <i
                              className="fa fa-th-large"
                              style={{
                                width: "1.25rem",
                                height: "1.25rem",
                                fontSize: "1.25rem"
                              }}
                            ></i>
                          </CButton>
                          <span
                            className="text-white ml-3 text-ellipsis"
                            style={{ position: "absolute", left: "3.5rem" }}
                          >
                            Abrir itens da atividade
                          </span>
                        </div>
                        <div className="d-flex align-items-center position-relative mt-3">
                          <CButton
                            color="live"
                            className="d-flex justify-content-center align-items-center flex-column text-white"
                            style={{ height: "3.5rem", width: "3.5rem" }}
                            onClick={() =>
                              this.props.history.push(
                                `/classroom/${this.state.room_id}`
                              )
                            }
                          >
                            <i
                              className="fa fa-home"
                              style={{
                                width: "1.25rem",
                                height: "1.25rem",
                                fontSize: "1.25rem"
                              }}
                            ></i>
                          </CButton>
                          <span
                            className="text-white ml-3 text-ellipsis"
                            style={{ position: "absolute", left: "3.5rem" }}
                          >
                            Voltar para a plataforma
                          </span>
                        </div>
                      </>
                    )}
                    <CButton
                      color="live"
                      className={`d-flex justify-content-center align-items-center flex-column text-white mt-3${
                        this.state.jitsiCollapse ? " rotate" : ""
                      }`}
                      style={{ height: "4.6875rem", width: "4.6875rem" }}
                      onClick={() =>
                        this.setState(state => ({
                          jitsiCollapse: !state.jitsiCollapse
                        }))
                      }
                    >
                      <i
                        className="fa fa-plus"
                        style={{
                          width: "1.25rem",
                          height: "1.25rem",
                          fontSize: "1.25rem"
                        }}
                      ></i>
                    </CButton>
                  </div>
                  {!late && !soon && (
                    <JitsiTeacher
                      room={this.getJitsiRoomName()}
                      user={this.props.user.user.name}
                      className="w-100 h-100"
                      onJitsi={jitsi => this.setState({ jitsiObj: jitsi })}
                      onStartRecording={() => this.onStartRecording()}
                      onStopRecording={() => this.onStopRecording()}
                    />
                  )}
                </>
              )}
            </div>
            <CCollapse show={!this.state.jitsi}>
              <div className="activity-live">
                <div className="main-container">
                  <Breadcrumb
                    current={this.props.currentRoute}
                    items={[
                      { path: "/classroom/me", to: "/classroom/me" },
                      {
                        path: "/classroom/:id/lives",
                        to: `/classroom/${this.state.activity?.room_id}/lives`
                      }
                    ]}
                    className="mb-2"
                  />
                  <CRow>
                    <CCol>
                      <h1 className="d-flex align-items-center text-tile">
                        {this.state.activity_name}
                        {!late && !soon && (
                          <CButton
                            color="primary"
                            className="ml-3"
                            style={{ marginTop: "3px" }}
                            onClick={() =>
                              this.setState(state => ({ jitsi: !state.jitsi }))
                            }
                          >
                            <i className="fa fa-video-camera mr-2"></i> Abrir
                            Jitsi
                          </CButton>
                        )}
                        <CButton
                          color="light"
                          className="ml-3"
                          style={{ marginTop: "3px" }}
                          onClick={() => this.setState({ shareModal: true })}
                        >
                          Compartilhar
                        </CButton>
                        {/* <CButton color="light" className="ml-3" style={{ marginTop: '3px' }} onClick={() => this.props.showHelpdesk()}>Solicitação</CButton> */}
                        <CButton
                          color="light"
                          className="ml-3"
                          style={{ marginTop: "3px" }}
                          onClick={() =>
                            this.props.history.push(
                              `/classroom/${this.state.room_id}`
                            )
                          }
                        >
                          Sair
                        </CButton>
                      </h1>
                      <h5 className="d-flex align-items-center">
                        <img
                          src={
                            URL.img +
                            (this.state.professor_photo ||
                              "uploads/users/profileEmpty.jpg")
                          }
                          style={{
                            borderRadius: "100%",
                            width: "2rem",
                            height: "2rem",
                            marginRight: "0.75rem"
                          }}
                        />
                        {this.state.professor_name}
                      </h5>
                    </CCol>
                  </CRow>
                  {![7, 8, 9].includes(
                    this.props.general.active_roles.role_id
                  ) ? (
                    <React.Fragment>
                      {!late && (
                        <CRow className="flex-1 mt-3">
                          <DragAndDropLive
                            ref={ref => (this.dragAndDropLive = ref)}
                            activity={this.state.activity_id}
                            allocation_id={this.state.allocation_id}
                            discipline={this.state.discipline}
                            dropArea
                            dropName="Itens selecionados"
                            direction="horizontal"
                            dontChangeListOnSelect
                            onInsert={item => this.insertActivityItem(item)}
                            onRemove={item => this.removeActivityItem(item)}
                            currentRoute={this.props.currentRoute}
                          />
                        </CRow>
                      )}
                      {!soon && (
                        <CRow className={`flex-1${late ? " mt-3" : ""}`}>
                          <CCol xs="6">
                            <div className="pt-3 d-flex align-items-center justify-content-between">
                              <h4 className="m-0">Itens</h4>
                              <i
                                onClick={() =>
                                  this.setState(state => ({
                                    leftCollapse: !state.leftCollapse
                                  }))
                                }
                                className={`text-muted activity-collapse fa fa-chevron-${
                                  this.state.leftCollapse ? "up" : "down"
                                }`}
                              ></i>
                            </div>
                            <hr
                              style={{
                                marginTop: "0.75rem",
                                marginBottom: "1.5rem"
                              }}
                            />
                            <CCollapse show={this.state.leftCollapse}>
                              <Widgets
                                itens={this.state.itens}
                                openItem={this.openItem}
                                closeItem={this.closeItem}
                              />
                            </CCollapse>
                          </CCol>
                          <CCol xs="6">
                            <div className="pt-3 d-flex align-items-center justify-content-between">
                              <h4 className="m-0">Usuários</h4>
                              <i
                                onClick={() =>
                                  this.setState(state => ({
                                    rightCollapse: !state.rightCollapse
                                  }))
                                }
                                className={`text-muted activity-collapse fa fa-chevron-${
                                  this.state.rightCollapse ? "up" : "down"
                                }`}
                              ></i>
                            </div>
                            <hr
                              style={{
                                marginTop: "0.75rem",
                                marginBottom: "1.5rem"
                              }}
                            />
                            <CCollapse show={this.state.rightCollapse}>
                              <Students
                                studentsList={this.state.studentsList}
                                listQuestion={this.state.listQuestion}
                                totalActivityItems={
                                  this.state.totalActivityItems
                                }
                                onSelect={e =>
                                  this.setState({
                                    selectedUser: e,
                                    modalCorrect: true
                                  })
                                }
                              />
                              <div className="w-100 d-flex mt-3">
                                <div style={{ width: "50%", display: "flex" }}>
                                  <div
                                    style={{
                                      width: "21px",
                                      height: "21px",
                                      borderRadius: "3px",
                                      backgroundColor: "#2eb85c",
                                      marginRight: "5px"
                                    }}
                                  ></div>
                                  Usuário dentro da atividade
                                </div>
                                <div style={{ width: "50%", display: "flex" }}>
                                  <div
                                    style={{
                                      width: "21px",
                                      height: "21px",
                                      borderRadius: "3px",
                                      backgroundColor: "#b1b7c1",
                                      marginRight: "5px"
                                    }}
                                  ></div>
                                  Usuário fora da atividade
                                </div>
                              </div>
                            </CCollapse>
                          </CCol>
                        </CRow>
                      )}
                    </React.Fragment>
                  ) : (
                    <>
                      {soon && !this.state.activity.activity_release ? (
                        <CRow className="flex-1 mt-3">
                          <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                            <img
                              src={ImgNoData}
                              style={{ height: "240px", marginBottom: "2rem" }}
                              alt=""
                            />
                            <p
                              style={{ fontSize: "1.5rem" }}
                              className="mb-2 font-weight-bold text-center"
                            >
                              A atividade ainda não foi liberada
                            </p>
                            <span className="text-muted text-center">
                              Tente voltar daqui a alguns minutos
                            </span>
                          </div>
                        </CRow>
                      ) : (
                        <CRow className="flex-1 mt-3">
                          {this.state.itens.length > 0 ? (
                            <CCol lg="12">
                              <div id="leftSide">
                                <Widgets
                                  itens={this.state.itens}
                                  openItem={this.openItem}
                                />
                              </div>
                            </CCol>
                          ) : (
                            <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                              <img
                                src={ImgNoData}
                                style={{
                                  height: "240px",
                                  marginBottom: "2rem"
                                }}
                                alt=""
                              />
                              <p
                                style={{ fontSize: "1.5rem" }}
                                className="mb-2 font-weight-bold text-center"
                              >
                                Nenhum conteúdo foi liberado ainda
                              </p>
                              <span className="text-muted text-center">
                                Use o chat para se comunicar com a turma
                              </span>
                            </div>
                          )}
                        </CRow>
                      )}
                    </>
                  )}
                  <CRow>
                    <div id="room_control" style={{ width: "100%" }}></div>
                  </CRow>
                </div>
                {!soon && (
                  <div className="chat-container">Live Chat - Deletado</div>
                )}
              </div>
            </CCollapse>
          </div>
        ) : (
          <div className="loading-container">
            <CSpinner color="secondary" size="md" />
          </div>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

ActivityLive.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

ActivityLive.defaultProps = {
  hideLayout: true,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  socket: state.socket
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj,
      showHelpdesk
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLive);
